module.exports = __webpack_public_path__ + "static/rocket2-da8835e6471f2165b2a12017dcfcd83a.png";